module.exports = __webpack_public_path__ + "img/shop_area_1.eef97fa8.jpg";